<template>
  <div class="fieldset">
    <template v-if="form">
      <h3 class="fieldset-heading">Other</h3>

      <Other v-model="form.other"/>

    </template>
  </div>
</template>

<script>
import {fieldsetHelpers} from "@/components/common/questionnaires/fieldsets/fieldsetHelpers";
import {statusOptions} from "@/components/common/questionnaires/question/options/statusOptions";
import {personalDetails} from "@/components/common/questionnaires/question/options/personalDetails";

import Other from "@/components/common/questionnaires/question/questions/amendment/Other.vue";

export default {
  name: 'OtherAmendment',
  mixins: [fieldsetHelpers, statusOptions, personalDetails],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  components: {
    Other,
  },
  data() {
    return {
      label: 'Other', // used for steps progress
      videoUrl: null
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        console.log('HERE---b---', this.value);
        return this.value
      }
    }
  }
};
</script>
